import { all } from 'redux-saga/effects'
import { billingAddressSaga } from './billing-address/sagas'
import { invoiceSaga } from './invoice/sagas'

export function* billingSaga() {
  yield all([billingAddressSaga(), invoiceSaga()])
}
